(function (window, document, undefined) {

  window.geolocation = {

    init: () => {

      let ls_value = window.geolocation.ls.get()
      console.log(`ls_value: ${ls_value}`);
      
      if (ls_value == false) {
        fetch(`${window.Shopify.routes.root}browsing_context_suggestions.json`, {
          method: 'GET'
        }).then(response => response.json()).then(response => {
          let detected_location_code = response.detected_values.country.handle.toLowerCase(),
              location_host = window.location.host,
              instance = '';
  
          if (location_host == 'myrtille.pl' || location_host == 'myrtille-pl.myshopify.com') {
            instance = 'pl'
          } else {
            instance = 'en';
          }
  
          if (instance == 'pl') {
            if (detected_location_code != 'pl') {
              window.geolocation.popup.open(instance, detected_location_code);
            }
          } else if (instance == 'en') {
            if (detected_location_code == 'pl') {
              window.geolocation.popup.open(instance, detected_location_code);
            }
          }
        });
  
        let _popup_btns = document.querySelectorAll('[data-geolocation-action="close"]');
        if (_popup_btns.length) {
          _popup_btns.forEach((btn) => {
            btn.addEventListener('click', () => {
              window.geolocation.popup.close();
            });
          });
        }
      }
    },

    popup: {

      open: (instance, detected_location_code) => {
        let _popup = document.querySelector('.geolocation');
        if (_popup) {
          _popup.setAttribute('data-instance', instance);
          _popup.setAttribute('data-detected', detected_location_code);
          _popup.classList.add('is_active');
        }
      },

      close: () => {
        let _popup = document.querySelector('.geolocation');
        if (_popup) {
          _popup.classList.remove('is_active');
          window.geolocation.ls.set();
        }
      }

    },

    ls: {
      get: () => {
        let v = localStorage.getItem('geolocation') != null ? localStorage.getItem('geolocation') : false;
        return v;
      },

      set: () => {
        localStorage.setItem('geolocation', 'closed');
      }
    }

  }

})(window, window.document);

document.addEventListener('DOMContentLoaded', () => {
  window.geolocation.init();
});
